import React from "react"
import clsx from "clsx"
import { IPersonnelNdfDocumentModel } from "@common-models/*"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"

interface Props {
     documents: IPersonnelNdfDocumentModel[]
     isLoading: boolean
     onAddClick: () => void
     onReplaceClick: (doc: IPersonnelNdfDocumentModel) => void
     onRemoveClick: (id: number, idx: number) => void
     onViewClick: (doc: IPersonnelNdfDocumentModel) => void
     isKm: boolean
}

export const NdfJustificatifsEditSection = ({ documents, isLoading, onAddClick, onReplaceClick, onRemoveClick, onViewClick, isKm }: Props) => (
     <div className="card shadow-sm border border-gray-300">
          <div className="card-header border-bottom bg-light">
               <h3 className="card-title align-items-start flex-column pt-4">
                    <span className={clsx("fw-boldest fs-4 mb-1", !isKm && "required")}>Justificatifs</span>
                    <span className="text-muted fs-8 fw-bold">Formats : PDF, JPG, PNG (Max 10MB)</span>
               </h3>
          </div>
          <div className="card-body position-relative">
               {/* Overlay de chargement (Bloque les clics pendant l'upload/suppression) */}
               {isLoading && (
                    <div
                         className="position-absolute w-100 h-100 top-0 start-0 bg-white bg-opacity-75 d-flex justify-content-center align-items-center"
                         style={{ zIndex: 10, borderRadius: "0.475rem" }}
                    >
                         <div className="d-flex flex-column align-items-center bg-white p-4 rounded shadow-sm border border-gray-200">
                              <MySimpleSpinner size="lg" />
                              <span className="mt-3 fw-bold text-gray-700">Traitement en cours...</span>
                         </div>
                    </div>
               )}

               <div className={clsx("d-flex flex-column gap-4", isLoading && "opacity-50")}>
                    {documents.length === 0 && <div className="p-10 border border-dashed text-center text-muted fs-7">Aucun document</div>}

                    {documents.map((doc, idx) => (
                         <div className="p-4 bg-light-primary bg-opacity-25 border border-primary border-dashed rounded-3" key={doc.id || idx}>
                              <div className="d-flex align-items-center">
                                   <div className="symbol symbol-45px me-3">
                                        <div className="symbol-label bg-white shadow-sm cursor-pointer" onClick={() => onViewClick(doc)}>
                                             <i className="fas fa-cloud-upload-alt text-primary fs-3"></i>
                                        </div>
                                   </div>
                                   <div className="flex-grow-1">
                                        <span className="fw-bold fs-7 text-gray-800">Justificatif n°{idx + 1}</span>
                                        <div className="d-flex gap-2 mt-1">
                                             <button
                                                  type="button"
                                                  className="btn btn-link btn-color-primary p-0 fs-8 fw-boldest"
                                                  onClick={() => onReplaceClick(doc)}
                                                  disabled={isLoading}
                                             >
                                                  Remplacer
                                             </button>
                                             <span className="text-gray-400">|</span>
                                             <button
                                                  type="button"
                                                  className="btn btn-link btn-color-info p-0 fs-8 fw-boldest"
                                                  onClick={() => onViewClick(doc)}
                                                  disabled={isLoading}
                                             >
                                                  Voir
                                             </button>
                                        </div>
                                   </div>
                                   <button
                                        type="button"
                                        className="btn btn-icon btn-sm btn-light-danger shadow-sm ms-3"
                                        onClick={() => onRemoveClick(doc.id as number, idx + 1)}
                                        disabled={isLoading}
                                   >
                                        <i className="fas fa-times fs-6"></i>
                                   </button>
                              </div>
                         </div>
                    ))}

                    <button
                         className="btn btn-light-primary btn-sm fw-boldest border border-primary border-dashed mt-2 py-3"
                         type="button"
                         onClick={onAddClick}
                         disabled={isLoading}
                    >
                         <i className="fas fa-plus-circle me-2" /> Ajouter un justificatif
                    </button>
               </div>
          </div>
     </div>
)
